import React from "react";
import { Link } from "react-router-dom";
import { DataTable } from "@cxagroup/casper";
import { injectIntl } from "react-intl";
import messages from "components/messagesDescription";
import { FormattedCustomDate } from "components/common/FormattedComponents";
import { RouteMap } from "components/common/navigation/routeMap";
import { isBeforeToday } from "cxa-utils/date";
import { renderAsHTML, decodeHtmlContent } from "../../../utils";
import { formatDateTime } from "../../../i18n/util";

const EmployeeDelegationTable = injectIntl(({ employees = [], intl, action }) => {
  const columns = [
    {
      fieldId: "delegatedEmployeeName",
      displayLabel: "Delegated employee",
      shouldDisplay: true,
      type: "String",
    },
    {
      fieldId: "delegatedEmail",
      displayLabel: "Email",
      shouldDisplay: true,
      type: "String",
    },
    {
      fieldId: "delegateFunction",
      displayLabel: "Function",
      shouldDisplay: true,
      type: "String",
    },
    {
      fieldId: "start",
      displayLabel: "From",
      shouldDisplay: true,
      type: "Date",
    },
    {
      fieldId: "end",
      displayLabel: "End",
      shouldDisplay: true,
      type: "Date",
    },
  ];

  const headers = columns.map(column => {
    if (!column.shouldDisplay) {
      return null;
    }

    return intl.formatMessage({
      id: column.displayLabel,
      defaultMessage: column.displayLabel,
    });
  });

  headers.push("");

  const rows = employees.map(item => {
    const isRevoked = item.revokeOn !== undefined;
    const isEnded = item.end && isBeforeToday(item.end);
    const row = columns.map(column => {
      let displayLabel = intl.formatMessage({
        id: item[column.fieldId],
        defaultMessage: item[column.fieldId],
      });

      if (column.type === "Date") {
        displayLabel = <FormattedCustomDate value={displayLabel} />;
      }
      if (typeof displayLabel == "string") {
        return renderAsHTML("span", displayLabel);
      }
      return displayLabel;
    });

    // Actions buttons
    row.push(
      isRevoked ? (
        <div>{intl.formatMessage(messages.delegation.employees.revokeOn)} {formatDateTime(item.revokeOn)}</div>
      ) : isEnded ? (
        <div />
      ) : (
        <div>
          <Link
            to={{
              pathname: `${RouteMap.EditDelegation}/${
                item.delegatedEmployeeKey
              }/${encodeURIComponent(decodeHtmlContent(item.delegatedEmployeeName))}/${
                item.entityKey
              }`,
            }}
          >
            {intl.formatMessage(messages.delegation.employees.editButton)}
          </Link>
          {" | "}
          <Link to={RouteMap.Delegation} onClick={() => action.revoke(item)}>
            {intl.formatMessage(messages.delegation.employees.revokeButton)}
          </Link>
        </div>
      )
    );

    return row;
  });

  return (
    <div className="apl-scroll-table">
      <DataTable headers={headers} rows={rows} />
    </div>
  );
});

export default EmployeeDelegationTable;



// WEBPACK FOOTER //
// ./components/employee/delegation/EmployeeDelegationTable.js